import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
export function WhyItWorks() {
  return <section className="w-full bg-cream py-20 sm:py-28" aria-labelledby="why-title" data-id="element-202" data-mp="36u0ab41r491h">
      <div className="mx-auto w-full max-w-4xl px-5 sm:px-8" data-id="element-203" data-mp="2t22ajjtxjphz">
        <SectionHeading eyebrow="¿Por qué esto funciona?" title="Porque no se escribió desde la teoría" data-id="element-204" data-mp="2x2cnxhk1xi6v" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.6
      }} className="mt-12 grid gap-8 md:grid-cols-[0.9fr_1.1fr] md:items-center" data-id="element-205" data-mp="3krov6bvtjg6j">
          <img src="https://cdn.shopify.com/s/files/1/0825/1706/5986/files/ChatGPT_Image_20_jun_2026_09_27_45_p.m..png?v=1786137860f" alt="Retrato de Ingrid Rosales, autora de Me Elijo" className="mx-auto h-56 w-56 rounded-full object-cover shadow-soft md:h-full md:w-full md:rounded-3xl" loading="lazy" data-id="element-206" data-mp="3gqd0vt2026s0" />
          <div data-id="element-207" data-mp="3u9fbwn541bu9">
            <p className="text-lg leading-relaxed text-ink/80" data-id="element-208" data-mp="3ub062bniisrl">
              Fue escrito en medio de lágrimas reales. En noches sin dormir. mientras intentaba sostener mi familia, mis negocios y no perderme a mí misma. No nació en un escritorio; nació en la vida real.
            </p>
            <p className="mt-5 text-lg leading-relaxed text-ink/80" data-id="element-209" data-mp="34yr3s0fff0o">
              Por eso aquí no hay juicios ni «deberías». Solo verdad, herramientas y un
              recordatorio suave:
            </p>
            <p className="mt-8 border-l-2 border-clay pl-6 font-display text-3xl italic leading-snug text-plum" data-id="element-210" data-mp="c1pwiv0vc67x">
              No puedes dar lo mejor de ti… si siempre te dejas para el final.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}